import React from 'react';
import { translate } from 'react-i18next';

import UIStatusDialog from 'components/UIStatusDialog.js';
import UserSettingActions from 'actions/UserSettingActions';

class AccountSettings extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      locale: Utils.getLocale(), 
    };
  }
  
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSave(e) {
    e.preventDefault();
    MakeShiftEmployeeDispatcher.dispatch({
      actionType: appConstants.ActionTypes.UPDATE_SETTINGS,
      postData: this.state,
    });
  }

  render() {
    const statusDialogs = [];
    for (let i = 0; i < this.props.statuses.length; i++) {
      statusDialogs.push(
        <UIStatusDialog
          status={this.props.statuses[i]}
          key={this.props.statuses[i].key}
          closeDialog={this.props.closeStatusDialog}
        />,
      );
    }

    return (
      <div className={this.props.activeState}>
        <form 
          className="account-settings"
          onSubmit={this.handleSave}
        >
          <fieldset>
            <legend>
              <h1>{this.props.t('AccountSettings.settings')}</h1>
            </legend>
            <div className="field">
              <label htmlFor="locale">{this.props.t('AccountSettings.language')}</label>
              <div className="styledSelect">
                <select
                  onChange={this.handleChange}
                  name="locale"
                  value={this.state.locale}
                >
                  <option value="en">{this.props.t('AccountSettings.english_us')}</option>
                  <option value="en_ca">{this.props.t('AccountSettings.english_ca')}</option>
                  <option value="fr">{this.props.t('AccountSettings.french')}</option>
                  <option value="es">{this.props.t('AccountSettings.spanish')}</option>
                </select>
              </div>
            </div>
            <div className="field">
              <input
                type="submit"
                value={this.props.t('AccountSettings.save_changes')}
              />
            </div>
          </fieldset>
          {statusDialogs}
        </form>
      </div>
    );
  }
}

export default translate()(AccountSettings);
